import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useProjectSiteParams } from '@/shared/lib';
import { useLazyPrintServiceRequestFormQuery } from '../api';

export interface PrintServiceRequestParams {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export const usePrintServiceRequest = ({ onSuccess, onError }: PrintServiceRequestParams) => {
  const { projectId, siteId } = useProjectSiteParams();
  const { i18n } = useTranslation();

  const [printForm, { isLoading, isFetching, isSuccess, isError, error }] = useLazyPrintServiceRequestFormQuery();

  const handlePrint = useCallback(
    async ({ id }: { id: number }) => {
      try {
        await printForm({
          id,
          projectId,
          siteId,
          lang: i18n.language
        }).unwrap();

        onSuccess?.();
      } catch (error) {
        onError?.(error);
        throw error;
      }
    },
    [printForm, projectId, siteId, i18n.language, onSuccess, onError]
  );

  return {
    printServiceRequest: handlePrint,
    isLoading: isLoading || isFetching,
    isSuccess,
    isError,
    error
  };
};
